import { render, staticRenderFns } from "./EditorNav.vue?vue&type=template&id=98f23648&scoped=true&"
import script from "./EditorNav.vue?vue&type=script&lang=js&"
export * from "./EditorNav.vue?vue&type=script&lang=js&"
import style0 from "./EditorNav.vue?vue&type=style&index=0&id=98f23648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f23648",
  null
  
)

component.options.__file = "EditorNav.vue"
export default component.exports